module.exports = __webpack_public_path__ + "img/submitHead.7915262b.png";